<template >

<div  :key="componentKey" >
  <v-container> 
  <v-card>
    <div class="row">
      <div class="col-md-4 col-sm-4 col-xs-12" >
        <v-carousel>
          <v-carousel-item
            :src="currentProduct.data.imageUrl"
          ></v-carousel-item>
        </v-carousel>
      </div>
      <div class="col-md-7 col-sm-7 col-xs-12"> 
        <div class="pl-6">
          <p class="display-1 mb-0">{{ currentProduct.data.itemName }}</p>
          <v-card-actions class="pa-0">
            <p class="headline font-weight-light pt-3">
              Ksh. {{ formatPrice(currentProduct.data.itemPrice) }}
              <del style="" class="subtitle-1 font-weight-thin">
                Ksh. {{ formatPrice(currentProduct.data.itemPrice) }}</del
              >
            </p>
            <v-spacer></v-spacer> 
            <v-rating
              v-model="rating"
              class=""
              background-color="warning lighten-3"
              color="warning"
              dense
            ></v-rating>
            <span class="body-2	font-weight-thin"> 25 REVIEWS</span>
          </v-card-actions>
          <p class="subtitle-1 font-weight-thin">
            {{ currentProduct.data.itemDescription }}
          </p>


        

          <!-- dialog strat --->
          <div class="text-center">
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="white--text ma-2"
                  color="red"
                  red
                  v-bind="attrs"
                  v-on="on"
                >
                  Buy Now
                  <v-icon dark right>
                    mdi-arrow-right
                  </v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Your Details
                </v-card-title>

                
<div class="amber lighten-2 ma-md-5 black--text">
                    <p v-if="errors.length"  class="pa-md-6">
                    <b> Please correct the error(s):</b>
                    <ul>
                      <li :key="error" v-for="error in errors">{{error}}</li> 
                    </ul>
                    </p>

</div>

                <v-card-text>
                  <v-form class="pa-md-4" >



<section v-if="showLocation">
<!-- places data here --> 

<h4 subtitle>Delivery Location.</h4>

<p v-if="locationError.length"  class="pa-md-6 red">
                    <b> Please correct the error(s):</b>
                    <ul>
                      <li :key="error" v-for="error in locationError">{{error}}</li> 
                    </ul>
                    </p>

<div class="ma-4">
    <v-text-field type="text" v-model="location" outlined label="Delivery Location"></v-text-field>
    <v-list three-line>

    
    <template  v-for="(result, i) in searchResults">


        <v-list-item class="grey lighten-3 "   :key="result.place_id" @click="getLocation(result)"> {{ result.description}} </v-list-item>

    </template>

    </v-list>

</div>

<!-- end places data --> 

<v-btn
                  class="white--text"
                    v-on:click="checkLogIn()"
                    large
                    right
                    color="red"
                      
                  >
                    Continue 
                  </v-btn>

  </section>                 

<section id="signup-form" v-if="showSignUp">
  <div class="pa-4">
                      <span class="label"> Have an account? </span>
  <div id="customBtn" class="customGPlusSignIn blue white--text">
    <span class="icon"></span>
    <span class="buttonText" @click="showLogin = true, showSignUp = false">Login</span>
  </div>

</div>
<br/> <br/>

                    <v-row>      
<v-divider></v-divider>
OR
  <v-divider></v-divider>
            </v-row>


          
            <span> Signup </span>


                    <v-text-field
                      v-model="firstName"
                      name = "firstName"
                      label="First Name"
                      :rules="[rules.required]"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="lastName"
                      name="lastName"
                      label="Last Name"
                      :rules="[rules.required]"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="phoneNumber"
                      name = "phoneNumber"
                      label="Phone Number"
                      :rules="[rules.required]"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="emailAddress"
                      name = "emailAddress"
                      :rules="[rules.email]"
                      label="Email Address"
                      outlined
                    ></v-text-field>

                      <v-text-field
                      v-model="password"
                      name = "password"
                      :rules="[rules.required]"
                      label="Password"
                      type="password"
                      outlined
                    ></v-text-field>
                                          
          

<br/>

          

  

  <v-btn
                  class="white--text"
                    @click="saveUserData(currentProduct.data.itemPrice);"
                    large
                    right
                    color="red"
                      
                  >
                    Continue
                  </v-btn>

                  <br/> <br/>


</section>


<section id="signup-form" v-if="showLogin">

<h5> Login to Sendsoko </h5>
<br/>

  <v-text-field
                      v-model="emailAddress_login"
                      name = "emailAddress_login"
                      :rules="[rules.email]"
                      label="Email Address"
                      outlined
                    ></v-text-field>

                      <v-text-field
                      v-model="password_login"
                      name = "password_login"
                      :rules="[rules.required]"
                      label="Password"
                      type="password"
                      outlined
                    ></v-text-field>

                      <v-btn
                  class="white--text"
                    @click="loginUser(currentProduct.data.itemPrice);"
                    large
                    right
                    color="red"
                      
                  >
                    Login
                  </v-btn>

                  <br/> <br/>

</section>


                    </v-form>
                    </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <!-- dialog end -->
        </div>
      </div>
    </div>
  </v-card>

    <div class="row">
      <div class="col-sm-12 col-xs-12 col-md-12">
        <v-tabs>
          <v-tab>Description</v-tab>
          <v-tab>Materials</v-tab>
          <v-tab>REVIEWS</v-tab>
          <v-tab-item>
            <p class="pt-10 subtitle-1 font-weight-thin"></p>
          </v-tab-item>
          <v-tab-item>
            <p class="pt-10 subtitle-1 font-weight-thin"></p>
          </v-tab-item>
          <v-tab-item>
            <v-list three-line="true" avatar="true">
              <v-list-item-group v-model="item" color="primary">
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  inactive="true"
                >
                  <v-list-item-avatar>
                    <v-img :src="item.avatar"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="item.title"></v-list-item-title
                    ><v-rating
                      v-model="rating"
                      class=""
                      background-color="warning lighten-3"
                      color="warning"
                      dense
                    ></v-rating>
                    <v-list-item-subtitle
                      v-html="item.subtitle"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-tab-item>
        </v-tabs>
        <v-card-text class="pa-0 pt-4" tile outlined>
            
          <div class="row text-center">
            <div
              v-for="product in similarProducts"
              :key="product.key"
              class="col-md-3 col-sm-4 col-xs-12 text-center"
            >
              <v-hover v-slot:default="{ hover }" open-delay="200">
                <v-card :elevation="hover ? 16 : 2" 
                  :to="{
                        name: 'Product',
                        params: { productId: product.key }
                      }"
                      @click="refreshSelf(product.key)">
                  <v-img
                    class="white--text align-end"
                      :aspect-ratio="16 / 9"
                      height="100px"
                    :src="product.data.imageUrl"
                  >
                    <v-card-title>{{ product.data.itemCategory }}</v-card-title>
                  </v-img>

                  <v-card-text class="text--primary text-center">
                    <div>{{ product.data.itemName }}</div>
                    <div>Ksh. {{ formatPrice(product.data.itemPrice) }}</div>
                  </v-card-text>

                  
                </v-card>
              </v-hover>
            </div>
          
          </div>
        </v-card-text>
      </div>
    </div>
  </v-container>
    

    
<link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet" type="text/css">

</div>
</template>


<script src="https://apis.google.com/js/api:client.js"></script>
  <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyA2rzOG3Xgl6BRxqfWXJp-goL9YeiyrN6U&libraries=places&callback=initMap&solution_channel=GMP_QB_addressselection_v1_cABC" async defer></script>



<style type="text/css">
  #customBtn {
    display: inline-block;
    background: white;
    color: #444;
    width: 190px;
    border-radius: 5px;
    border: thin solid #888;
    box-shadow: 1px 1px 1px grey;
    white-space: nowrap;
  }
  #customBtn:hover {
    cursor: pointer;
  }
  span.label {
    font-family: serif;
    font-weight: normal;
  }
  span.icon {
    background: url('/identity/sign-in/g-normal.png') transparent 5px 50% no-repeat;
    display: inline-block;
    vertical-align: middle;
    width: 42px;
    height: 42px;
  }
  span.buttonText {
    display: inline-block;
    vertical-align: middle;
    padding-left: 42px;
    padding-right: 42px;
    font-size: 14px;
    font-weight: bold;
    /* Use the Roboto font that is loaded in the <head> */
    font-family: 'Roboto', sans-serif;
  }
</style>


<script> 
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/satellite-min.css';
import { mapState, mapActions } from "vuex";  


export default {
created() {
    window.scrollTo(0, 0); 
  this.$store.dispatch("doAdder");
  this.$store.dispatch("getCurr");
  this.$store.dispatch("getProducts"); 
  this.$store.dispatch("getCategories");
  this.$store.commit("setId", this.$route.params.productId);
  this.$store.commit("setCurr", this.$route.params.productId);
  this.$store.dispatch("checkAuthStatus");
  
},
computed: { 

userName : {
  
  get(){
    return this.$store.state.loggedInName
    }
},

userEmail: { 
  get()  {
    return this.$store.state.loggedInEmail  
    }
},
  
    
  mapState:mapState ({
    count: state => state.count,
    curr: state => state.curr,
    currId: state => state.currId
  }),
  currentProduct() {
    return this.$store.state.curr;
  },
  similarProducts() {
    return this.$store.state.similar;
  }

  
},

data: () => ({
  componentKey: 0,
    searchClient: algoliasearch(
      '3AV9AUVNSM',
      'f82adba3bcff8507a51e40c9d21e1f6a'
    ),
      rules: {
        required: value => !!value || 'Required.', 
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      showSignUp: false,
      showLocation: true,
      showLogin: false,
  amount: 0,
  rating: 4.5,
  firstName: "",
  lastName: "",
  
  phoneNumber: "",
  emailAddress: "",
  password: "",
  password_login: "",
  emailAddress_login:"",
  buyerLocation: {},
  item: 5,
  items: [],
  errors:[],
  locationError:[],

  dialog: false,
    location: '',
    searchResults: [],
    service: null // will reveal this later 🕵️
}),

metaInfo () {
    return {
      script: [{
        src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyD4xPGzQhGjTuyuIjHVca5VcgvxRewCoSI&libraries=places`,
        async: true,
        defer: true,
        callback: () => this.MapsInit() // will declare it in methods
      }]
    }
  },


methods: {
      ref : this,
       checkLogIn() {

         /*
       .then(res => {

    this.dialog = false; 

    console.log("whats here? whats there! before payments");
      this.makePayment(priceAmount,res);
    console.log(res);

    }).catch((error) => {
      console.log("error from master: "+ error);
      this.errors.push(error);

    });
   
 */
    this.$store.dispatch("checkAuthStatus").then(res => {

    console.log("The login function says: " + res);
      
    console.log(res+res+res+res+res+res);
    if(res === "true"){
          //launch payment activity 

          var emailAddress = this.$store.state.loggedInEmail;
          this.makePayment(this.currentProduct.data.itemPrice,emailAddress );
        }
        else{
          alert("Not logged!")
          this.showSignUp = true;
          this.showLocation = false
        }


    }).catch((error) => {
      console.log("error from function home: "+ error);
      this.errors.push(error);

    });

/*
        var logState = this.$store.state.logState;
        console.log("LOggedin state"+  logState);
        alert(logState);
        if(logState === "true"){
          //launch payment activity 

          this.emailAddress = this.$store.state.loggedInEmail;
          this.makePayment(this.currentProduct.data.itemPrice,this.emailAddress );
        }
        else{
          alert("Not logged!")
          this.showSignUp = true;
          this.showLocation = false
        }

        */
       },
  
getLocation(userLocation){
console.log(JSON.stringify(userLocation)); 

this.location = userLocation.description;
this.buyerLocation = userLocation; 
this.predictions = [];
},
      getPhoneAuth(){
        this.$store.dispatch("authenticateUserPhone");
      },
getAuth() {

if(this.location) {
this.$store.dispatch("authenticateUserGoogle",this.buyerLocation)
.then(res => {

    this.dialog = false; 

    console.log("whats here? whats there! before payments");
      this.makePayment(priceAmount,res);
    console.log(res);

    }).catch((error) => {
      console.log("error from master: "+ error);
      this.errors.push(error);

    });


} 

if(!this.location){
  this.locationError.push("Add a location first");
}
},
  saveUserData(priceAmount) {
  this.errors = [];
        if (this.firstName && this.lastName && this.phoneNumber && this.emailAddress && this.password) {
    
        
      console.log(  this.firstName +
      this.lastName +
      this.phoneNumber +
      this.emailAddress + 'as form data');

      const user = {
          firstName:this.firstName,
      lastName:this.lastName,
      phoneNumber:this.phoneNumber,
      emailAddress:this.emailAddress,
      password: this.password,
      buyerLocation: this.buyerLocation
      }
    
    this.$store.dispatch(
      "signupWithEmailAndPassword",
      user
    ).then(res => {

    this.dialog = false; 
      this.makePayment(priceAmount);
    console.log(res);

    }).catch((error) => {
      console.log("error from master: "+ error);
      this.errors.push(error);

    });
    
    
      }
    
    if(!this.firstName){this.errors.push("First Name is required!")}
    if(!this.lastName){this.errors.push("Last Name is required!")}
    if(!this.phoneNumber){this.errors.push("Phone number is required!")}
    if(!this.emailAddress){this.errors.push("Email address is required!")}
  },

loginUser(priceAmount){
alert(this.$store.state.loggedIn);

  if (this.emailAddress_login && this.password_login) { 

  const user = {  
      emailAddress:this.emailAddress_login,
      password: this.password_login,
      buyerLocation: this.buyerLocation
      }
      

this.$store.dispatch(
      "authenticateUserEmailAndPassword",
      user
    ).then(res => {

    this.dialog = false; 
      this.makePayment(priceAmount,res);
    console.log("res"+ res+ this.priceAmount);

    }).catch((error) => {
      console.log("error from master: "+ error);
      this.errors.push(error);

    });
  }

  
    if(!this.emailAddress_login){this.errors.push("Email address is required!")}
      if(!this.password_login){this.errors.push("Password is required!")}
},

  
  refreshSelf(key) {
  
    this.$store.commit("setId", key);
    this.$store.commit("setCurr", this.$store.getters.productList[key]);
    console.log("data from shop" + this.$store.getters.productList[key]);
    console.log("current key is:" + this.$store.state.currId);
    console.log("current curr is:" + this.$store.state.curr);
    window.scrollTo(0, 0);
  },

  resetSearch() { 

    //this method is not being users due to errors
      document
      .querySelectorAll('.ais-SearchBox-input')
      .forEach((e) => (e.value = ''))

    // clear all the hits
    document.querySelectorAll('.ais-Hits-item').forEach((e) => e.remove())

    // also clear the hits from the component, otherwise subsequent searches throw exceptions
  this.$refs.searchHits.state.hits = []

    this.componentKey += 1;
    
},


  formatPrice(value) {
    let val = (value / 1).toFixed(0).replace(",", ".");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  makePayment(priceAmount,userEmail) {
    var ref = this;
    this.amount = priceAmount;
    this.$launchFlutterwave({
      tx_ref: Date.now(),
      amount: this.amount,
      currency: "KES",
      payment_options: "card,mobilemoney",
      customer: {
        email: userEmail,
        phonenumber: this.phoneNumber,
        name: this.firstName +" " +this.lastName,
      },
      callback: function(response) {
        // specified callback function
        console.log("the response is: "+ response.toString());

        /**
         * save to firebase 
         * response message as an object 
         */
        
          console.log( JSON.stringify(response));
            ref.$store.commit("saveTransactionRecord",response);

      },
        onclose: function(){
          console.log("modal closed!");
        
        },
      customizations: {
        title: "Sendsoko",
        description: "Payment for products from sendsoko",
        logo: "https://assets.piedpiper.com/logo.png"
      }
    });
  },

  MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction) 
    }

},

watch: {
    location (newValue) {
      if (newValue) {
        this.service.getPlacePredictions({
          input: this.location, 
        }, this.displaySuggestions)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Product.vue